import { render } from "./InjuryTypeDistributionChart.vue?vue&type=template&id=a717bc1c&scoped=true"
import script from "./InjuryTypeDistributionChart.vue?vue&type=script&lang=js"
export * from "./InjuryTypeDistributionChart.vue?vue&type=script&lang=js"

import "./InjuryTypeDistributionChart.vue?vue&type=style&index=0&id=a717bc1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a717bc1c"]])

export default __exports__